
import { authHeader } from '../helpers/authHeader';
import apiClient from '../helpers/apiClient';


export const creditNoteService = {
    creditNoteList, submitCreditNote,
      creditNoteDetails, creditNoteStatus,
      creditNoteByDate, creditNoteSearch,
      downloadCreditNotePdf
  
    
};



async function  creditNoteByDate(form) {
    return  apiClient.post(`/inventory/credit-note-by-date`, form, authHeader());
}
async function  creditNoteSearch(searchText) {
    return  apiClient.get(`/inventory/credit-note-search?search=${searchText}`, authHeader());
}




async function  creditNoteList() {
    return  apiClient.get(`/inventory/credit-note`, authHeader());
}


async function  creditNoteDetails(id) {
    return  apiClient.get(`/inventory/credit-note-details/${id}`, authHeader());
}

async function  downloadCreditNotePdf(id) {
    return  apiClient.get(`/inventory/credit-note-pdf/${id}`, { ...authHeader(), responseType: 'blob' });
}


async function  submitCreditNote(form) {
    return  apiClient.post(`/inventory/submit-credit-note`, form, authHeader());
}

async function  creditNoteStatus(form) {
    return  apiClient.put(`/inventory/credit-note-status`, form, authHeader());
}











